
import { Component, ElementRef, HostListener, ViewChild, input, signal, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { PlatformService } from 'src/app/core/services/platform/platform.service';
import { KEY } from '../image-carousel-full-screen/image-carousel-full-screen.component';
import { PinchZoomComponent } from "./pinch-zoom/pinch-zoom.component";

@Component({
  standalone: true,
  selector: 'webstore-mobile-image-carousel-full-screen',
  templateUrl: './mobile-image-carousel-full-screen.component.html',
  styleUrls: ['./mobile-image-carousel-full-screen.component.scss'],
  imports: [CommonModule, PinchZoomComponent]
})
export class MobileImageCarouselFullScreenComponent {
  private platformService = inject(PlatformService);


  IMAGE_URLS = IMAGE_URLS;

  @ViewChild('slideCarousel') slideCarousel!: CarouselComponent;
  @ViewChild('carouselContainer') carouselContainer!: ElementRef;

  isBrowser = this.platformService.isBrowser();
  isDragging: boolean = false;

  customOptions: OwlOptions = {
    items: 4,
    loop: false,
    margin: 20,
    autoplay: false,
    autoWidth: false,
    dots: false,
    responsive: {
      0: {
        items: 4
      },
      600: {
        items: 4
      },
      900: {
        items: 4
      }
    },
    nav: false
  };



  readonly previewIndexInput = input<number>(0);
  readonly imagesListInput = input<string[]>([]);

  // Internal signals for component state
  private _previewIndex = signal<number>(0);
  private _images = signal<{
    image: string;
    thumbImage: string;
    alt: string;
    title: string;
    widthForSlider: number;
  }[]>([]);
  private _previewImage = signal<string>('');

  // Getters for backward compatibility
  get previewIndex() { return this._previewIndex(); }
  get imagesList() { return this._images().map(img => img.image); }
  get images() { return this._images(); }
  get previewImage() { return this._previewImage(); }

  constructor() {
    effect(() => {
      const previewIndexValue = this.previewIndexInput();
      this._previewIndex.set(previewIndexValue);
    });

    effect(() => {
      const images = this.imagesListInput();
      if (Array.isArray(images)) {
        const mappedImages = images.map((url: string) => ({
          image: url,
          thumbImage: url,
          alt: '',
          title: '',
          widthForSlider: 120
        }));

        this._images.set(mappedImages);

        const firstImage = mappedImages && mappedImages.length && mappedImages[0]?.image
          ? mappedImages[0].image
          : '';
        this._previewImage.set(firstImage);

        if (Array.isArray(images) && images && images.length <= (this.customOptions.items ?? 4)) {
          this.customOptions = {
            ...this.customOptions,
            autoWidth: true,
            margin: 10
          };
        }
      } else {
        // when no image is set
        this._images.set([]);
        this._previewImage.set('');
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === KEY.LEFT_ARROW) {
      this.previous();
    }
    if (event.key === KEY.RIGHT_ARROW) {
      this.next();
    }
  }

  previous() {
    if (this._previewIndex() === 0)
      return
    this._previewIndex.set(this._previewIndex() - 1);
  }

  next() {
    if (this.imagesList && this._previewIndex() >= this.imagesList.length - 1)
      return

    this._previewIndex.set(this._previewIndex() + 1);
  }

  updatePreviewImage(index: number) {
    this._previewIndex.set(index);
  }


}

